// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__QgBzl","header":"ClearentDisclaimer_header__T2uii","inner":"ClearentDisclaimer_inner__2ty1V"};